import React from 'react'
import { Card, Drawer, Form, Table, Icon, notification, Button, Popover, Tooltip, Checkbox, Input, Row, Col } from 'antd'
import _ from 'lodash'
import { connect } from 'react-redux'
import Request from '../../request'
import { TableComp, FormUtils as GetAllFormFields } from 'sz-react-utils'
import moment from 'moment';
import { RightsWrapper } from '../_utils/utils'

let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
const activeUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
@Form.create()

class EditInvoiceView extends React.Component {
    state = {
        visible: true,
        invoiceType: '',
        companyBankId: '',
        invoiceNumber: '',
        invoiceGeneratedDate: '',
        taxTypeId: '',
        cpTaxTypeId: '',
        invoiceToId: '',
        showInvoiceNumber: false,
        showInvoiceDate: false,
        allInvoiceToDetails: [],
        companyDetails: [],
        allTaxes: [],
        taxTypeArray: [],
        countryArr: [],
        generatedInvoice: {},
        invoiceLinkWith: '',
        universities: [],
        channelPartners: [],
        selectMultipleRecords: [],
        enableBTN: false,
        selectedStudents: [],
        universityCommissions: [],
        invoiceThroughCp: false,
        hasConversionRate: false,
        taxPercentange: 0
    }
    handleInvoiceTSubmit = e => {
        const { form } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData)
                let x = await Request.addInvoiceToDetails(values)

                if (!x.error) {
                    notification.success({
                        message: 'Invoice To Added successfully'
                    })
                    form.resetFields()
                    this.getAllInvoiceToDetails();
                    this.closeInvoiceTODetailsDrawar();
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.msg
                    })
                }
            }
        })
    }
    handleCompanySubmit = e => {
        const { form } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData)
                let x = await Request.addCompanyDetails(values);

                if (!x.error) {
                    notification.success({
                        message: 'Bank Added successfully'
                    })
                    form.resetFields()
                    this.loadCompanyBankDetails();
                    this.closeCompanyDetailsDrawar();
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.msg
                    })
                }
            }
        })
    }
    handleTaxSubmit = e => {
        const { form } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData)
                values.taxTypeArray = this.state.taxTypeArray;
                let x = await Request.addTaxDetails(values);

                if (!x.error) {
                    notification.success({
                        message: 'Tax Detail Added successfully'
                    })
                    form.resetFields()
                    this.getAllTaxes();
                    this.closeTaxDetailsDrawar();
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.msg
                    })
                }
            }
        })
    }
    loadCountry() {
        let params = {
            results: 100,
            sortField: "countryName",
            sortOrder: "ascend",
            businessId: activeUser && activeUser.businessId
        };
        Request.getCountriesWithoutAuth(params)
            .then((resp) => {
                if (resp) {
                    let temp = [];
                    _.each(resp.data, (vv) => {
                        temp.push({
                            display: vv.countryName,
                            id: vv._id,
                        });
                    });
                    this.setState({ countryArr: temp });
                }
            })
            .catch((err) => {
            });
    }
    getAllInvoiceToDetails = async () => {
        let params = {};
        params.results = 10000;
        params.count = 10000;
        params.sortField = 'invoiceToName'
        params.sortOrder = 'ascend'
        let data = await Request.getInvoiceToDetails({
            ...params,
            regExFilters: []
        });
        this.setState({ allInvoiceToDetails: data.data });
    }
    getAllTaxes = async () => {
        let params = {};
        params.results = 10000;
        params.count = 10000;
        let data = await Request.getTaxDetails({
            ...params,
            regExFilters: []
        });
        this.setState({ allTaxes: data.data });
    }
    loadCompanyBankDetails = async () => {
        let response = await Request.getCompanyBankDetails();
        if (!response.error) {
            this.setState({ companyDetails: response.results });
        } else {
            notification.error({
                message: 'Error generating invoice'
            })
        }
    }
    loadUniversity = async () => {
        Request.loadSimpleUniversities({ sort: { instituteName: 1 } })
            .then(resp => {
                resp.arr = resp.arr.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.universityInstitutionName })
                    return temp
                }, [])

                this.setState({ 'universities': resp.arr });
            })
            .catch(err => {
                console.log(err)
            })
    }
    loadChannelPartner = async () => {
        Request.loadChannelPartners({
            results: 10000,
            count: 1000
        })
            .then(resp => {
                resp.data = resp.data.reduce((temp, vv) => {
                    temp.push({ _id: vv._id, display: vv.channelPartnerName })
                    return temp
                }, [])

                this.setState({ 'channelPartners': resp.data });
            })
            .catch(err => {
                console.log(err)
            })
    }

    // loadInvoiceDetail = async () => {
    //     const { selectMultipleRecords } = this.state;
    //     var universityId = [];
    //     for (let key in selectMultipleRecords) {
    //         let obj = selectMultipleRecords[key];
    //         universityId.push(obj.universityId);
    //     }
    //     let uniResponse = await Request.getCommissionUniversities({ universityId });
    //     let selectMultipleRecordData = [];
    //     if (uniResponse.data) {
    //         uniResponse.data.map((comm, index) => {
    //             for (let key in selectMultipleRecords) {
    //                 let record = selectMultipleRecords[key];
    //                 if (record.universityId == comm.universityId) {
    //                     record.commissionFromUniversity = comm.status === "Pending" || comm.status === "Inactive" ? 0 : comm.commissionFromUniversity
    //                     record.commissionTypeFrom = comm.commissionTypeFrom
    //                 }
    //                 selectMultipleRecordData[key] = record;
    //             }
    //         })
    //     }
    //     this.setState({ selectMultipleRecords: selectMultipleRecordData });
    //     let studentIds = Object.keys(selectMultipleRecords)
    //     let response = await Request.loadDashboardStudentList({
    //         arr: studentIds,
    //         results: 10000,
    //     });
    //     if (response.data) {
    //         this.setState({ selectedStudents: response.data })
    //     }
    // }

    loadInvoiceDetail = async () => {
        const { invoiceId } = this.props;
        const res = await Request.getInvoiceDetail(invoiceId);
        if (!res.error) {
            this.setState({ generatedInvoice: res.doc });
            if (res.doc.invoiceThroughCp) {
                this.setState({ invoiceThroughCp: res.doc.invoiceThroughCp })
            }
            if (res.doc.hasConversionRate) {
                this.setState({ hasConversionRate: res.doc.hasConversionRate });
            }
            if (res.doc.cpTaxTypeId) {
                this.updateCpTax(res.doc.cpTaxTypeId)
            }
        }
    }

    async componentDidMount() {
        this.loadInvoiceDetail();
        let selectMultipleRecords = this.props.selectMultipleRecords;
        this.setState({ selectMultipleRecords }, async () => {
            await this.loadInvoiceDetail();
        });
        this.loadCompanyBankDetails();
        this.getAllTaxes();
        this.getAllInvoiceToDetails();
        this.loadCountry();
        this.loadUniversity();
        this.loadChannelPartner();
    }
    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    selectCompanyDetais = (e) => {
        this.setState({ companyBankId: e.target.value });
    }

    updateCpTax = async (e) => {
        if (e === "") {
            this.setState({ cpTaxTypeId: e, taxPercentange: 0 })
        }
        let response = await Request.financeTaxDetailsByID({ id: e })
        let { taxTypeArray } = response.doc
        let totalTaxPercentage = 0
        _.each(taxTypeArray, (tax) => {
            totalTaxPercentage += parseFloat(tax.taxValue)
        })
        this.setState({ cpTaxTypeId: e, taxPercentange: totalTaxPercentage })

    }

    doSubmitCompanyBankId = async (e) => {
        const { invoiceId } = this.props;
        const { generatedInvoice, showInvoiceDate, hasConversionRate } = this.state;
        if (!generatedInvoice.invoiceGeneratedDate && showInvoiceDate) {
            return notification.error({
                message: 'Invoice Date Is Required!'
            })
        }
        if (!generatedInvoice.companyBankId) {
            return notification.error({
                message: 'Company Is Required!'
            })
        }
        if (generatedInvoice.taxPaidBy == 'University' && !generatedInvoice.taxTypeId) {
            return notification.error({
                message: 'Tax Is Required!'
            })
        }
        generatedInvoice.hasConversionRate = this.state.hasConversionRate;
        const { dispatch } = this.props;
        this.setState({ enableBTN: true })
        let response = await Request.financeUpdateInvoice({
            generatedInvoice,
            invoiceId,
            hasConversionRate
        });
        this.setState({ enableBTN: false })
        if (!response.error) {
            notification.success({ message: 'Invoice updated Successfully' });
            this.props.onClose()
        } else {
            notification.error({
                message: 'Error generating invoice'
            })
        }

    }


    removeUserFromInvoice = (invoice) => {
        let generatedInvoice = this.state.generatedInvoice
        generatedInvoice.invoices = generatedInvoice.invoices.filter((item) => item.studentId !== invoice.studentId)
        this.setState({ generatedInvoice })
    }

    closeCompanyDetailsDrawar = () => {
        this.setState({ showCompanyDetailsDrawar: false });
    }

    closeTaxDetailsDrawar = () => {
        this.setState({ showTaxDetailsDrawar: false });
    }

    closeInvoiceTODetailsDrawar = () => {
        this.setState({ showInvoiceToDetailsDrawar: false });
    }

    render() {

        const {
            form: { getFieldDecorator }
        } = this.props
        const { enableBTN, generatedInvoice, companyDetails, universities, countryArr, id, taxTypeArray, channelPartners, allTaxes, taxPaidBy, allInvoiceToDetails, showInvoiceNumber, showInvoiceDate } = this.state;
        const inputTypesCompany = {
            fields: [
                {
                    label: 'Company Name',
                    key: 'companyName',
                    required: true
                },
                {
                    label: 'Company Type',
                    key: 'companyType',
                    required: true
                },
                {
                    label: 'Company Email',
                    key: 'companyEmail',
                    required: true,
                    type: 'email'
                },
                {
                    label: 'Bank Name',
                    key: 'bankName',
                    required: true
                },
                {
                    label: 'Bank Address',
                    key: 'bankAddress',
                    required: true
                },
                {
                    label: 'Account Number',
                    key: 'accountNumber',
                    required: true
                },
                {
                    label: 'Account Name',
                    key: 'accountName',
                    required: true
                },
                {
                    label: 'Bank Swift/BIC',
                    key: 'bankSwiftBicCode'
                },
                {
                    label: 'Bank Ifsc Code',
                    key: 'bankIfscCode'
                },
                {
                    label: 'Transit Number',
                    key: 'transitNumber'
                },
                {
                    label: 'Institution Number',
                    key: 'institutionNumber'
                },
                {
                    label: 'HST Registration Number',
                    key: 'HSTRegistrationNumber'
                },
                {
                    label: 'Status',
                    key: 'companyStatus',
                    type: 'select',
                    required: true,
                    showSearch: true,
                    disabled: false,
                    options: [
                        'Active', 'Inactive'
                    ],
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            companyStatus: v
                        })
                    }
                }
            ]
        };
        let content = <p>This invoice is created when your student is enrolled in an institute through a channel partner.<br />
            Enter all the details received by your channel partner to create the invoice.</p>
        const inputTypesTax = {
            fields: [
                {
                    label: 'Tax Title',
                    key: 'taxTitle'
                },
                {
                    label: 'Select Country ',
                    key: 'countryId',
                    required: true,
                    type: 'select',
                    showSearch: true,
                    disabled: false,
                    options: countryArr,
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            countryId: v
                        })
                    }
                },
                {
                    label: 'Status',
                    key: 'taxStatus',
                    type: 'select',
                    required: true,
                    showSearch: true,
                    disabled: false,
                    options: [
                        'Active', 'Inactive'
                    ],
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            taxStatus: v
                        })
                    }
                },
                {
                    label: 'Tax Type',
                    key: 'taxTypeKeyWord',
                    customProps: {
                        style: {
                            width: '75%'
                        }
                    },
                    rightComp: <Button style={{ marginLeft: '3px' }} type="primary" onClick={() => {
                        let taxType = this.props.form.getFieldValue('taxTypeKeyWord');
                        let taxTypeArray = this.state.taxTypeArray;
                        taxTypeArray.push({
                            taxName: taxType,
                            taxValue: 0
                        })
                        this.setState({ taxTypeArray });
                    }}>{<Icon type="plus" />}</Button>
                }
            ]
        };
        const inputTypesInvoice = {
            fields: [
                {
                    label: 'Invoice To Name',
                    key: 'invoiceToName',
                    required: true
                },
                {
                    label: 'Invoice Address',
                    key: 'invoiceAddress',
                    required: true
                },
                {
                    label: 'Kind Attention',
                    key: 'kindAttention',
                    required: true
                },
                {
                    label: 'Invoice Email',
                    key: 'invoiceToEmail',
                    required: true,
                    type: 'email'
                },
                {
                    label: 'Invoice Phone',
                    key: 'invoiceToPhone',
                    required: true
                },
                {
                    label: 'Invoice Category',
                    key: 'invoiceToCategory',
                    required: true
                },
                {
                    label: 'Status',
                    key: 'invoiceToStatus',
                    type: 'select',
                    required: true,
                    showSearch: true,
                    disabled: false,
                    options: [
                        'Active', 'Inactive'
                    ],
                    onChange: v => {
                        this.props.form.setFieldsValue({
                            invoiceToStatus: v
                        })
                    }
                },
                {
                    label: 'Invoice Linked With',
                    key: 'invoiceLinkWith',
                    type: 'select',
                    required: true,
                    showSearch: true,
                    disabled: false,
                    options: [
                        'University', 'Channel Partner'
                    ],
                    onChange: v => {
                        this.setState({ invoiceLinkWith: v });
                        this.props.form.setFieldsValue({
                            invoiceLinkWith: v
                        })
                    }
                },
                {
                    label: 'University',
                    key: 'universityId',
                    type: 'select',
                    required: true,
                    showSearch: true,
                    disabled: false,
                    options: universities,
                    hidden: (this.state.invoiceLinkWith != 'University'),
                    onChange: v => {
                        this.setState({ universityId: v });
                        this.props.form.setFieldsValue({
                            universityId: v
                        })
                    }
                },
                {
                    label: 'Channel Partner',
                    key: 'channelPartnerId',
                    type: 'select',
                    required: true,
                    showSearch: true,
                    disabled: false,
                    options: channelPartners,
                    hidden: (this.state.invoiceLinkWith != 'Channel Partner'),
                    onChange: v => {
                        this.setState({ channelPartnerId: v });
                        this.props.form.setFieldsValue({
                            channelPartnerId: v
                        })
                    }
                }
            ]
        };

        let taxColumns = [
            {
                title: 'Tax Name',
                key: 'taxName',
                render: (text, record) => {
                    return (
                        <div>{record.taxName}</div>
                    )
                }
            },
            {
                title: 'Value',
                key: 'taxValue',
                dataIndex: 'taxValue',
                render: (item, record, index) => {
                    return (<div>
                        <Input type='tax' onChange={(e) => {
                            taxTypeArray[index].taxValue = e.target.value;
                            this.setState({ taxTypeArray });
                        }} value={record.taxValue} />
                    </div>)
                }
            }
        ]
        let $this = this;
        let invoiceReceivingDate = generatedInvoice.invoiceGeneratedDate ? moment(generatedInvoice.invoiceGeneratedDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
        let totalAmount = generatedInvoice.invoices && generatedInvoice.invoices.reduce(function (oldValue, invoice) { return (invoice.commissionTypeFrom == 'Percentage' ? (parseFloat(invoice.commissionFromCourse) * parseFloat(invoice.tutionFee) / 100) : parseFloat(invoice.commissionFromCourse)) + oldValue; }, 0);
        let totalCommissionAmount = generatedInvoice.invoices && generatedInvoice.invoices.reduce(function (oldValue, invoice) { return (invoice.commissionTypeFrom == 'Percentage' ? ((parseFloat(invoice.commissionFromCourse) * parseFloat(invoice.tutionFee) / 100) * parseFloat(invoice.receivedCommission) / 100) : parseFloat(invoice.receivedCommission)) + oldValue; }, 0);
        let totalConvertedAmountReceived = generatedInvoice.invoices && generatedInvoice.invoices.reduce(function (oldValue, invoice) { return (invoice.commissionTypeFrom == 'Percentage' ? (((parseFloat(invoice.commissionFromCourse) * parseFloat(invoice.tutionFee) / 100) * parseFloat(invoice.receivedCommission) / 100) * parseFloat(invoice.conversionRate)) : parseFloat(invoice.receivedCommission)) + oldValue; }, 0);
        let netPaymentReceived = generatedInvoice.invoices && generatedInvoice.invoices.reduce(function (oldValue, invoice) { return (invoice.commissionTypeFrom == 'Percentage' ? ((((parseFloat(invoice.commissionFromCourse) * parseFloat(invoice.tutionFee) / 100) * parseFloat(invoice.receivedCommission) / 100) * parseFloat(invoice.conversionRate)) + parseFloat(invoice.IgstAmount)) : parseFloat(invoice.receivedCommission)) + oldValue; }, 0);
        return (
            <Drawer
                title={
                    <div>
                        {'Edit Invoice:- '} {' '} {generatedInvoice.invoiceNumber}<b>/</b>{moment(generatedInvoice.invoiceGeneratedDate).format(dateFormat)}
                        <a onClick={this.onClose} style={{ float: 'right', color: 'black' }}>
                            <Icon type={'close'} />
                        </a>
                    </div>
                }
                placement="right"
                closable={false}
                onClose={this.onClose}
                width={this.state.invoiceThroughCp ? 1250 : 1000}
                visible={this.state.visible}>
                <Card>
                    <Row>

                        <Col span={12}>
                            {this.state.invoiceThroughCp ?
                                <Row>
                                    <Col span={8}>
                                        <select value={this.state.cpTaxTypeId} name='taxTypeId' style={{ 'maxWidth': '300px', 'marginBottom': '10px' }} className='form-control' onChange={(e) => this.updateCpTax(e.target.value)}>
                                            <option value="">Choose Tax</option>
                                            {
                                                allTaxes && allTaxes.length ?
                                                    allTaxes.map((item, index) => {
                                                        return (<option value={item._id} key={index}>{item.taxTitle}</option>)
                                                    })
                                                    : null
                                            }
                                        </select>
                                    </Col>
                                </Row>
                                : null}
                        </Col>
                        <Col span={12}>
                            <Checkbox
                                checked={this.state.hasConversionRate}
                                onChange={(y) => {
                                    this.setState({ hasConversionRate: y.target.checked })
                                }}
                            >Have Conversion Rate <Popover placement='bottomLeft' content={content}>?</Popover>
                            </Checkbox>
                        </Col>
                    </Row>
                    <div className='ant-table ant-table-small ant-table-bordered ant-table-scroll-position-left ant-table-layout-fixed'>
                        <div className='ant-table-content'>
                            <div className='ant-table-scroll scrolling-table' style={{ overflow: 'auto' }}>
                                <table className='ant-table-fixed' >
                                    <thead className='ant-table-thead'>
                                        <tr>
                                            <th className='ant-table-row-cell-break-word'>Student ID</th>
                                            <th className='ant-table-row-cell-break-word'>Student Name</th>
                                            <th className='ant-table-row-cell-break-word'>Date Of Birth</th>
                                            <th className='ant-table-row-cell-break-word'>Course</th>
                                            <th className='ant-table-row-cell-break-word'>Course Start Date</th>
                                            <th className='ant-table-row-cell-break-word'>Tuition Fee Paid</th>
                                            <th className='ant-table-row-cell-break-word'>Commission Percentage</th>
                                            <th className='ant-table-row-cell-break-word'>Commission Amount</th>
                                            <th className='ant-table-row-cell-break-word' hidden={this.state.invoiceThroughCp ? false : true}>% Received Comm.</th>
                                            <th className='ant-table-row-cell-break-word' hidden={this.state.invoiceThroughCp ? false : true}>Commission Received by CP</th>
                                            <th className='ant-table-row-cell-break-word' hidden={this.state.invoiceThroughCp && this.state.hasConversionRate ? false : true}>Conversion Rate</th>
                                            <th className='ant-table-row-cell-break-word' hidden={this.state.invoiceThroughCp && this.state.hasConversionRate ? false : true}>Net Amount</th>
                                            <th className='ant-table-row-cell-break-word' hidden={this.state.invoiceThroughCp && this.state.hasConversionRate ? false : true}>Tax Amount</th>
                                            <th className='ant-table-row-cell-break-word' hidden={this.state.invoiceThroughCp && this.state.hasConversionRate ? false : true}>Adjustment</th>
                                            <th className='ant-table-row-cell-break-word' hidden={this.state.invoiceThroughCp && this.state.hasConversionRate ? false : true}>Gross Amount</th>
                                            <th className='ant-table-row-cell-break-word'>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className='ant-table-tbody'>
                                        {
                                            generatedInvoice.invoices && generatedInvoice.invoices.map((invoice, index) => {
                                                let selectedStudent = invoice.inquiry
                                                return (
                                                    <tr key={index}>
                                                        <td className='ant-table-row-cell-break-word'>{selectedStudent && selectedStudent.visaDesk && selectedStudent.visaDesk.selectedCourse && selectedStudent.visaDesk.selectedCourse.instituteStudentId ? selectedStudent.visaDesk.selectedCourse.instituteStudentId : selectedStudent && selectedStudent.instituteStudentId ? selectedStudent.instituteStudentId : ''}</td>
                                                        <td className='ant-table-row-cell-break-word'>{selectedStudent && selectedStudent.studentName}</td>
                                                        <td className='ant-table-row-cell-break-word'>{selectedStudent && selectedStudent.dateOfBirth ? moment(selectedStudent.dateOfBirth).format(dateFormat) : ''}</td>
                                                        <td className='ant-table-row-cell-break-word'>{selectedStudent && selectedStudent.visaDesk ? selectedStudent.visaDesk.selectedCourse.courseName : ''}{selectedStudent && selectedStudent.visaDesk ? selectedStudent.visaDesk.selectedCourse.campusName ? `(${selectedStudent.visaDesk.selectedCourse.campusName})` : '' : ''}</td>
                                                        <td className='ant-table-row-cell-break-word'>{selectedStudent && selectedStudent.visaDesk ? moment(selectedStudent.visaDesk.courseStartDate).format(dateFormat) : ''}</td>
                                                        <td className='ant-table-row-cell-break-word'>
                                                            <Input
                                                                type='text'
                                                                value={invoice.tutionFee}
                                                                onChange={(e) => {
                                                                    generatedInvoice.invoices[index].tutionFee = e.target.value
                                                                    this.setState({ generatedInvoice })
                                                                }}
                                                            />
                                                        </td>
                                                        <td className='ant-table-row-cell-break-word'>
                                                            <Input
                                                                type='text'
                                                                value={invoice.commissionFromCourse}
                                                                onChange={(e) => {
                                                                    generatedInvoice.invoices[index].commissionFromCourse = e.target.value
                                                                    this.setState({ generatedInvoice })
                                                                }}
                                                            />
                                                        </td>
                                                        <td className='ant-table-row-cell-break-word'>{invoice.commissionTypeFrom == 'Percentage' ? (parseFloat(invoice.commissionFromCourse) * parseFloat(invoice.tutionFee) / 100).toFixed(2) : (invoice.commissionFromCourse ? parseFloat(invoice.commissionFromCourse).toFixed(2) : '')}</td>
                                                        <td className='ant-table-row-cell-break-word' hidden={this.state.invoiceThroughCp ? false : true}>
                                                            <Input
                                                                type='text'
                                                                value={(invoice.receivedCommission)}
                                                                onChange={(e) => {
                                                                    generatedInvoice.invoices[index].receivedCommission = e.target.value;
                                                                    this.setState({ generatedInvoice });
                                                                }}
                                                            />
                                                        </td>

                                                        <td className='ant-table-row-cell-break-word' hidden={this.state.invoiceThroughCp ? false : true}>{invoice.commissionTypeFrom == 'Percentage' ? ((parseFloat(invoice.commissionFromCourse) * parseFloat(invoice.tutionFee) / 100) * parseFloat(invoice.receivedCommission) / 100).toFixed(2) : (parseFloat(invoice.commissionFromCourse) * parseFloat(invoice.receivedCommission) / 100).toFixed(2)}</td>
                                                        <td className='ant-table-row-cell-break-word' hidden={this.state.invoiceThroughCp && this.state.hasConversionRate ? false : true}>
                                                            <Input
                                                                type='text'
                                                                value={invoice.conversionRate}
                                                                onChange={(e) => {
                                                                    generatedInvoice.invoices[index].conversionRate = e.target.value;
                                                                    this.setState({ generatedInvoice });
                                                                }}
                                                            />
                                                        </td>
                                                        <td className='ant-table-row-cell-break-word' hidden={this.state.invoiceThroughCp && this.state.hasConversionRate ? false : true}>{invoice.commissionTypeFrom == 'Percentage' ? ((((parseFloat(invoice.commissionFromCourse) * parseFloat(invoice.tutionFee) / 100) * parseFloat(invoice.receivedCommission) / 100)) * parseFloat(invoice.conversionRate) - (this.state.taxPercentange && this.state.taxPercentange > 0 ?
                                                            ((((parseFloat(invoice.commissionFromCourse) * parseFloat(invoice.tutionFee) / 100) * parseFloat(invoice.receivedCommission) / 100)) * parseFloat(invoice.conversionRate) * this.state.taxPercentange / (this.state.taxPercentange + 100))
                                                            : 0)).toFixed(2) : ((parseFloat(invoice.commissionFromCourse) * parseFloat(invoice.receivedCommission) / 100) * parseFloat(invoice.conversionRate)) - (this.state.taxPercentange && this.state.taxPercentange > 0 ?
                                                                (((parseFloat(invoice.commissionFromCourse) * parseFloat(invoice.receivedCommission) / 100) * parseFloat(invoice.conversionRate)) * this.state.taxPercentange / (this.state.taxPercentange + 100)).toFixed(2)
                                                                : 0)}</td>
                                                        <td className='ant-table-row-cell-break-word' hidden={this.state.invoiceThroughCp && this.state.hasConversionRate ? false : true}>{invoice.commissionTypeFrom == 'Percentage' ? ((((parseFloat(invoice.commissionFromCourse) * parseFloat(invoice.tutionFee) / 100) * parseFloat(invoice.receivedCommission) / 100)) * parseFloat(invoice.conversionRate) * this.state.taxPercentange / (this.state.taxPercentange + 100)).toFixed(2) : this.state.taxPercentange && this.state.taxPercentange > 0 ?
                                                            (((parseFloat(invoice.commissionFromCourse) * parseFloat(invoice.receivedCommission) / 100) * parseFloat(invoice.conversionRate)) * this.state.taxPercentange / (this.state.taxPercentange + 100)).toFixed(2)
                                                            : 0}</td>
                                                        <td className='ant-table-row-cell-break-word' hidden={this.state.invoiceThroughCp && this.state.hasConversionRate ? false : true}>
                                                            <Input
                                                                type='text'
                                                                value={invoice.adjustmentAmount ? invoice.adjustmentAmount : ""}
                                                                onChange={(e) => {
                                                                    generatedInvoice.invoices[index].adjustmentAmount = e.target.value;
                                                                    this.setState({ generatedInvoice });
                                                                }}
                                                            />
                                                        </td>


                                                        {/* <td className='ant-table-row-cell-break-word' hidden={this.state.invoiceThroughCp?false:true}>{invoice.commissionTypeFrom == 'Percentage' ? (((((parseFloat(invoice.commissionFromCourse) * parseFloat(invoice.tutionFee) / 100) * parseFloat(invoice.receivedCommission) / 100) * parseFloat(invoice.conversionRate))) + parseFloat((((((parseFloat(invoice.commissionFromCourse) * parseFloat(invoice.tutionFee) / 100)) * parseFloat(invoice.receivedCommission) / 100) * parseFloat(invoice.conversionRate))* parseFloat(this.state.taxPercentange)/100).toFixed(2)) + parseFloat(invoice.adjustmentAmount?invoice.adjustmentAmount:0)).toFixed(2): 0}</td> */}
                                                        <td className='ant-table-row-cell-break-word' hidden={this.state.invoiceThroughCp && this.state.hasConversionRate ? false : true}>{
                                                            invoice.commissionTypeFrom == 'Percentage' ?
                                                                (((((parseFloat(invoice.commissionFromCourse) * parseFloat(invoice.tutionFee) / 100) * parseFloat(invoice.receivedCommission) / 100)) * parseFloat(invoice.conversionRate) - (this.state.taxPercentange && this.state.taxPercentange > 0 ?
                                                                    ((((parseFloat(invoice.commissionFromCourse) * parseFloat(invoice.tutionFee) / 100) * parseFloat(invoice.receivedCommission) / 100)) * parseFloat(invoice.conversionRate) * this.state.taxPercentange / (this.state.taxPercentange + 100))
                                                                    : 0)) + ((((parseFloat(invoice.commissionFromCourse) * parseFloat(invoice.tutionFee) / 100) * parseFloat(invoice.receivedCommission) / 100)) * parseFloat(invoice.conversionRate) * this.state.taxPercentange / (this.state.taxPercentange + 100)))
                                                                : (((((parseFloat(invoice.commissionFromCourse) * parseFloat(invoice.receivedCommission) / 100) * parseFloat(invoice.conversionRate)) - (this.state.taxPercentange && this.state.taxPercentange > 0 ?
                                                                    (((parseFloat(invoice.commissionFromCourse) * parseFloat(invoice.receivedCommission) / 100) * parseFloat(invoice.conversionRate)) * this.state.taxPercentange / (this.state.taxPercentange + 100))
                                                                    : 0)) + (this.state.taxPercentange && this.state.taxPercentange > 0 ?
                                                                        (((parseFloat(invoice.commissionFromCourse) * parseFloat(invoice.receivedCommission) / 100) * parseFloat(invoice.conversionRate)) * this.state.taxPercentange / (this.state.taxPercentange + 100))
                                                                        : 0)) + (invoice.adjustmentAmount ? parseFloat(invoice.adjustmentAmount) : 0)).toFixed(2)
                                                        }</td>
                                                        <td>
                                                            <RightsWrapper myRight={"financeInvoices.delete"}>
                                                                <Button onClick={() => this.removeUserFromInvoice(invoice)} shape='circle' size='small' icon='delete' />
                                                            </RightsWrapper>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                    <tfoot className='ant-table-tfoot'>
                                        <tr>
                                            <th className='ant-table-row-cell-break-word'>Total:- </th>
                                            <th className='ant-table-row-cell-break-word'></th>
                                            <th className='ant-table-row-cell-break-word'></th>
                                            <th className='ant-table-row-cell-break-word'></th>
                                            <th className='ant-table-row-cell-break-word'></th>
                                            <th className='ant-table-row-cell-break-word'></th>
                                            <th className='ant-table-row-cell-break-word'></th>
                                            <th className='ant-table-row-cell-break-word'>{totalAmount ? totalAmount.toFixed(2) : ''}</th>
                                            <th className='ant-table-row-cell-break-word' hidden={this.state.invoiceThroughCp ? false : true}></th>
                                            <th className='ant-table-row-cell-break-word' hidden={this.state.invoiceThroughCp ? false : true}>{totalCommissionAmount ? totalCommissionAmount.toFixed(2) : ''}</th>
                                            <th className='ant-table-row-cell-break-word' hidden={this.state.invoiceThroughCp ? false : true}></th>
                                            <th className='ant-table-row-cell-break-word' hidden={this.state.invoiceThroughCp ? false : true}>{totalConvertedAmountReceived ? totalConvertedAmountReceived.toFixed(2) : ""}</th>
                                            <th className='ant-table-row-cell-break-word' hidden={this.state.invoiceThroughCp ? false : true}></th>
                                            <th className='ant-table-row-cell-break-word' hidden={this.state.invoiceThroughCp ? false : true}>{netPaymentReceived ? netPaymentReceived.toFixed(2) : ""}</th>


                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                </Card>
                <Card>
                    <Row>
                        <Col span={24}>
                            <select
                                name='invoiceType'
                                style={{ 'maxWidth': '300px', 'marginBottom': '10px' }}
                                className='form-control'
                                value={generatedInvoice.invoiceType}
                                onChange={(e) => {
                                    generatedInvoice.invoiceType = e.target.value
                                    this.setState({ generatedInvoice })
                                }}
                            >
                                <option value="">Choose Invoice Type</option>
                                <option value="Performa">Performa Invoice</option>
                                <option value="Invoice">Invoice</option>
                            </select>
                        </Col>
                        <Col span={24}>
                            <label><b>Invoice Number</b></label>
                            <Row style={{ 'marginBottom': '10px', 'marginTop': '10px', 'marginLeft': '5px' }}>
                                <Col span={4}>
                                    <Button className={!showInvoiceNumber ? 'btn-invoice-active' : ''} onClick={() => { this.setState({ showInvoiceNumber: false }) }}>Auto Generate</Button>
                                </Col>
                                <Col span={5}>
                                    <Button className={showInvoiceNumber ? 'btn-invoice-active' : ''} onClick={() => { this.setState({ showInvoiceNumber: true }) }}>Manually Generate</Button>
                                </Col>
                            </Row>
                            {
                                showInvoiceNumber ?
                                    <Input
                                        type={'text'}
                                        name="invoiceNumber"
                                        style={{ 'maxWidth': '300px', 'marginBottom': '10px' }}
                                        placeholder="Invoice Number"
                                        value={generatedInvoice.invoiceNumber}
                                        onChange={(e) => {
                                            generatedInvoice.invoiceNumber = e.target.value
                                            this.setState({ generatedInvoice })
                                        }}
                                    />
                                    : null
                            }

                        </Col>
                        <Col span={24}>
                            <label><b>Invoice Date</b></label>
                            <Row style={{ 'marginBottom': '10px', 'marginTop': '10px', 'marginLeft': '5px' }}>
                                <Col span={4}>
                                    <Button className={!showInvoiceDate ? 'btn-invoice-active' : ''} onClick={() => { this.setState({ showInvoiceDate: false }) }}>Auto Select</Button>
                                </Col>
                                <Col span={5}>
                                    <Button className={showInvoiceDate ? 'btn-invoice-active' : ''} onClick={() => { this.setState({ showInvoiceDate: true }) }}>Manually Select</Button>
                                </Col>
                            </Row>
                            {
                                showInvoiceDate ?
                                    <Input
                                        type={'date'}
                                        style={{ 'maxWidth': '300px', 'marginBottom': '10px' }}
                                        name="invoiceGeneratedDate"
                                        placeholder="Invoice Date"
                                        value={invoiceReceivingDate}
                                        onChange={(e) => {
                                            generatedInvoice.invoiceGeneratedDate = e.target.value
                                            this.setState({ generatedInvoice })
                                        }}
                                    />
                                    : null
                            }
                        </Col>

                        <Col span={24}>
                            <Row>
                                <Col span={8}>
                                    <select
                                        name='companyBankId'
                                        value={generatedInvoice.companyBankId}
                                        style={{ 'maxWidth': '300px', 'marginBottom': '10px' }}
                                        className='form-control'
                                        onChange={(e) => {
                                            generatedInvoice.companyBankId = e.target.value
                                            this.setState({ generatedInvoice })
                                        }}
                                    >
                                        <option value="">Choose Bank Details</option>
                                        {
                                            companyDetails && companyDetails.length ?
                                                companyDetails.map((item, index) => {
                                                    return (<option value={item._id} key={index}>{item.companyName}</option>)
                                                })
                                                : null
                                        }
                                    </select>
                                </Col>
                                <Col span={4}>
                                    <Button className='ant-btn-primary' onClick={(e) => { this.setState({ showCompanyDetailsDrawar: true }) }} type='button'>+</Button>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={24}>
                            <select
                                name='taxPaidBy'
                                value={generatedInvoice.taxPaidBy}
                                style={{ 'maxWidth': '300px', 'marginBottom': '10px' }}
                                className='form-control'
                                onChange={(e) => {
                                    generatedInvoice.taxPaidBy = e.target.value
                                    this.setState({ generatedInvoice })
                                }}
                            >
                                <option value="">Choose Tax Paid By</option>
                                <option value="Company">Company</option>
                                <option value="University">University</option>
                            </select>
                        </Col>
                        {
                            generatedInvoice.taxPaidBy ?
                                <Col span={24}>
                                    <Row>
                                        <Col span={8}>
                                            <select
                                                name='taxTypeId'
                                                value={generatedInvoice.taxTypeId}
                                                style={{ 'maxWidth': '300px', 'marginBottom': '10px' }}
                                                className='form-control'
                                                onChange={(e) => {
                                                    generatedInvoice.taxTypeId = e.target.value
                                                    this.setState({ generatedInvoice })
                                                }}
                                            >
                                                <option value="">Choose Tax</option>
                                                {
                                                    allTaxes && allTaxes.length ?
                                                        allTaxes.map((item, index) => {
                                                            return (<option value={item._id} key={index}>{item.taxTitle}</option>)
                                                        })
                                                        : null
                                                }
                                            </select>
                                        </Col>
                                        <Col span={4}>
                                            <Button className='ant-btn-primary' onClick={(e) => { this.setState({ showTaxDetailsDrawar: true }) }} type='button'>+</Button>
                                        </Col>
                                    </Row>
                                </Col>
                                : null
                        }
                        <Col span={24}>
                            <Row>
                                <Col span={8}>
                                    <select
                                        name='invoiceToId'
                                        value={generatedInvoice.invoiceToId}
                                        style={{ 'maxWidth': '300px', 'marginBottom': '10px' }}
                                        className='form-control'
                                        onChange={(e) => {
                                            generatedInvoice.invoiceToId = e.target.value
                                            this.setState({ generatedInvoice })
                                        }}>
                                        <option value="">Choose Invoice To</option>
                                        {
                                            allInvoiceToDetails && allInvoiceToDetails.length ?
                                                allInvoiceToDetails.map((item, index) => {
                                                    return (<option value={item._id} key={index}>{item.invoiceToName}</option>)
                                                })
                                                : null
                                        }
                                    </select>
                                </Col>
                                <Col span={4}>
                                    <Button className='ant-btn-primary' onClick={(e) => { this.setState({ showInvoiceToDetailsDrawar: true }) }} type='button'>+</Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Button
                        type="primary"
                        loading={enableBTN}
                        disabled={enableBTN}
                        onClick={() => this.doSubmitCompanyBankId()}> Update
                    </Button>
                </Card>
                <Drawer
                    title={
                        <div>
                            New Bank Detail
                        </div>
                    }
                    width={500}
                    closable={false}
                    onClose={this.closeCompanyDetailsDrawar}
                    visible={this.state.showCompanyDetailsDrawar}>
                    <div>
                        <Form onSubmit={this.handleCompanySubmit} style={{ marginTop: 8 }}>
                            <div>
                                <GetAllFormFields
                                    inputSchema={inputTypesCompany}
                                    getFieldDecorator={getFieldDecorator}
                                />
                            </div>
                            <Row>
                                <Col span={8} />
                                <Col span={8}>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        style={{ marginBottom: 10 }}
                                        loading={this.props.loading}>
                                        SAVE
                                    </Button>
                                </Col>
                                <Col span={8} />
                            </Row>
                        </Form>
                    </div>
                </Drawer>
                <Drawer
                    title={
                        <div>
                            New Tax Detail
                        </div>
                    }
                    width={500}
                    closable={false}
                    onClose={this.closeTaxDetailsDrawar}
                    visible={this.state.showTaxDetailsDrawar}>
                    <div>
                        <Form onSubmit={this.handleTaxSubmit} style={{ marginTop: 8 }}>
                            <div>
                                <GetAllFormFields
                                    inputSchema={inputTypesTax}
                                    getFieldDecorator={getFieldDecorator}
                                />
                                {
                                    taxTypeArray && taxTypeArray.length > 0 &&
                                    <Col span={18} offset={6}>
                                        <Table
                                            rowKey={(item, x) => {
                                                return x
                                            }}
                                            dataSource={taxTypeArray || []}
                                            columns={taxColumns}
                                            pagination={false}
                                            border={true}
                                        />
                                    </Col>
                                }
                            </div>
                            <Row style={{ 'clear': 'both' }}>
                                <Col span={8} />
                                <Col span={8}>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        style={{ marginBottom: 10 }}
                                        loading={this.props.loading}>
                                        SAVE
                                    </Button>
                                </Col>
                                <Col span={8} />
                            </Row>
                        </Form>
                    </div>
                </Drawer>
                <Drawer
                    title={
                        <div>
                            New Invoice To Detail
                        </div>
                    }
                    width={500}
                    closable={false}
                    onClose={this.closeInvoiceTODetailsDrawar}
                    visible={this.state.showInvoiceToDetailsDrawar}>
                    <div>
                        <Form onSubmit={this.handleInvoiceTSubmit} style={{ marginTop: 8 }}>
                            <div>
                                <GetAllFormFields
                                    inputSchema={inputTypesInvoice}
                                    getFieldDecorator={getFieldDecorator}
                                />
                            </div>
                            <Row>
                                <Col span={8} />
                                <Col span={8}>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        style={{ marginBottom: 10 }}
                                        loading={this.props.loading}>
                                        SAVE
                                    </Button>
                                </Col>
                                <Col span={8} />
                            </Row>
                        </Form>
                    </div>
                </Drawer>
            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditInvoiceView)